import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

// PERBAIKAN: Dibuat string kosong agar menggunakan relative path yang dijembatani Nginx VPS
const API_BASE_URL = '';

const GuruList = ({ token }) => {
  const [gurus, setGurus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchData();
  }, [token]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/guru`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setGurus(res.data);
    } catch (err) {
      console.error(err);
      setError('Gagal mengambil data guru.');
    }
    loading !== null && setLoading(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Yakin hapus guru ini? Akun loginnya juga akan terhapus.")) {
      try {
        await axios.delete(`${API_BASE_URL}/api/guru/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        fetchData();
      } catch (err) {
        alert('Gagal menghapus data guru.');
      }
    }
  };

  // --- HELPER FORMAT TANGGAL INDONESIA ---
  const formatTanggal = (isoString) => {
    if (!isoString || isoString === '0000-00-00') return '-';
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString; 
    
    return date.toLocaleDateString('id-ID', {
        day: 'numeric', month: 'long', year: 'numeric'
    });
  };

  // --- FUNGSI LIHAT DETAIL (POP-UP) ---
  const handleDetail = (g) => {
    Swal.fire({
        title: `<span style="font-size:18px; color:#1e293b">${g.nama}</span>`,
        html: `
            <div style="text-align: left; font-size: 14px; line-height: 1.8; color:#475569;">
                <div style="background:#f8fafc; padding:10px; border-radius:8px; margin-bottom:10px; border:1px solid #e2e8f0;">
                    <div><b>🆔 NIP:</b> <span style="font-family:monospace; color:#334155">${g.nip}</span></div>
                    <div><b>📚 Mapel:</b> ${g.mapel}</div>
                    <div><b>🚻 Gender:</b> ${g.jenis_kelamin === 'L' ? 'Laki-laki' : g.jenis_kelamin === 'P' ? 'Perempuan' : '-'}</div>
                    <div><b>🎂 Tgl Lahir:</b> ${formatTanggal(g.tgl_lahir)}</div>
                </div>
                <div style="border-top:1px dashed #cbd5e1; margin:10px 0;"></div>
                <div><b>📞 No. HP:</b> ${g.no_hp || '<span style="color:#94a3b8">(- Kosong -)</span>'}</div>
                <div><b>📧 Email:</b> ${g.email || '<span style="color:#94a3b8">(- Kosong -)</span>'}</div>
                <div style="margin-top:5px;"><b>🏠 Alamat:</b><br/>${g.alamat || '<span style="color:#94a3b8">(- Kosong -)</span>'}</div>
            </div>
        `,
        confirmButtonText: 'Tutup',
        confirmButtonColor: '#334155',
        width: '450px',
        background: '#fff'
    });
  };

  // --- IMPORT EXCEL ---
  const handleImport = async () => {
    const { value: file } = await Swal.fire({
        title: 'Import Data Guru',
        html: `<p style="font-size:13px; color:#64748b">Format Excel (.xlsx):<br/><b>NAMA, NIP, MAPEL, TGL_LAHIR, JK, ALAMAT, HP, EMAIL</b></p>`,
        input: 'file',
        showCancelButton: true,
        confirmButtonText: 'Upload',
        confirmButtonColor: '#10b981'
    });

    if (file) {
        const formData = new FormData();
        formData.append('file', file);
        try {
            setLoading(true);
            const res = await axios.post(`${API_BASE_URL}/api/import-guru`, formData, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
            });
            Swal.fire('Sukses', `Berhasil import ${res.data.sukses} guru.`, 'success');
            fetchData();
        } catch (err) {
            Swal.fire('Gagal', 'Terjadi kesalahan import.', 'error');
        }
        setLoading(false);
    }
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
            <h2 style={{ color: '#1e293b', margin: 0 }}>👨‍🏫 Data Guru</h2>
            <p style={{ margin: '5px 0 0', color: '#64748b', fontSize: '13px' }}>Klik nama guru untuk melihat biodata lengkap.</p>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
            <button onClick={handleImport} style={{ padding: '10px 20px', background: '#10b981', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>📥 Import Excel</button>
            <Link to="/guru/tambah">
                <button style={{ padding: '10px 20px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>+ Tambah Guru</button>
            </Link>
        </div>
      </div>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {!loading && !error && (
        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa', textAlign: 'left' }}>
                <th style={{ padding: '15px' }}>NIP</th>
                <th style={{ padding: '15px' }}>Nama Guru</th>
                <th style={{ padding: '15px' }}>Mata Pelajaran</th>
                <th style={{ padding: '15px', textAlign: 'center' }}>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {gurus.map((g) => (
                <tr key={g.id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '15px', fontWeight: 'bold', color:'#334155', fontFamily:'monospace' }}>{g.nip}</td>
                  
                  {/* KLIK NAMA UNTUK LIHAT DETAIL */}
                  <td 
                    onClick={() => handleDetail(g)} 
                    style={{ padding: '15px', fontWeight: '600', color: '#4361ee', cursor: 'pointer', textDecoration:'underline' }}
                    title="Klik untuk lihat biodata lengkap"
                  >
                    {g.nama}
                  </td>

                  <td style={{ padding: '15px' }}>
                    <span style={{ background: '#e0f2fe', color: '#0369a1', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight:'600' }}>
                      {g.mapel}
                    </span>
                  </td>
                  <td style={{ padding: '15px', textAlign: 'center' }}>
                    <Link to={`/guru/edit/${g.id}`}>
                      <button style={{ marginRight: '5px', padding: '6px 12px', background: '#f59e0b', color:'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Edit</button>
                    </Link>
                    <button onClick={() => handleDelete(g.id)} style={{ padding: '6px 12px', background: '#ef476f', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Hapus</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default GuruList;